document.addEventListener('DOMContentLoaded', () => {
  const crossfadeContainers = document.querySelectorAll('.cmb-crossfade');

  crossfadeContainers.forEach(container => {
    const slides = container.querySelectorAll('.cmb-image-wrap');
    if (slides.length < 3) return; // Static grid takes over if < 3

    // Pulls the exact speed you set in the Shopify editor
    const speed = parseInt(container.getAttribute('data-speed')) || 5000;
    let currentIndex = 0;

    setInterval(() => {
      // Fade out current slide
      slides[currentIndex].classList.remove('active');
      
      // Move to next slide, loop back to 0 if at the end
      currentIndex = (currentIndex + 1) % slides.length;
      
      // Fade in new slide
      slides[currentIndex].classList.add('active');
    }, speed);
  });
});